import { Text, DesignLanguage, useIsDesignLanguage } from '@afterpaytouch/core'
import { useTranslation } from '../../utils/convergence'
import { useCheckoutSizes } from '../../utils/responsive'
import React, { FC } from 'react'

export const TooltipContent: FC = () => {
  const { t } = useTranslation()
  const isArcadeDesignLanguage = useIsDesignLanguage(DesignLanguage.Arcade)
  const { textSize, smallTextSize } = useCheckoutSizes()
  const fontSize = isArcadeDesignLanguage ? smallTextSize : textSize
  return (
    <div>
      {!isArcadeDesignLanguage && <Text size={fontSize}>{t('paymentMethod:tooltipLineOne')}</Text>}
      {!isArcadeDesignLanguage && <p />}
      <Text size={fontSize}>{t('paymentMethod:tooltipLineTwo')}</Text>
    </div>
  )
}
